import { render, staticRenderFns } from "./ListSelector.component.vue?vue&type=template&id=2979e7d0&scoped=true&lang=pug"
import script from "./ListSelector.component.vue?vue&type=script&lang=ts"
export * from "./ListSelector.component.vue?vue&type=script&lang=ts"
import style0 from "./ListSelector.component.vue?vue&type=style&index=0&id=2979e7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979e7d0",
  null
  
)

export default component.exports